import { BrowserDownloader, type DownloadProgressCallback } from '@/services/BrowserDownloader';
import { getFileExtension } from './urls';
import type { NamedDownloadableAsset, FileEntry } from '@/types/downloadable';

const downloader = new BrowserDownloader({ preferFilePicker: false });
const sanitizeName = (name: string) => name.replace(/[/\\:*?"<>|]/g, '_');

export async function downloadNamedAssets({
  assets,
  archiveName,
  onProgress,
  signal,
}: {
  assets: NamedDownloadableAsset[];
  archiveName: string;
  onProgress: DownloadProgressCallback;
  signal: AbortSignal;
}): Promise<void> {
  const blobUrls: string[] = [];
  try {
    const files = assets.map(({ name, asset }, index): FileEntry => {
      const extension = asset.extension || getFileExtension(asset.url || '', asset.type);
      const baseName = assets.length === 1 ? sanitizeName(name) : `outputs_${String(index + 1).padStart(4, '0')}`;
      let url = asset.url || '';
      if (asset.blob) {
        url = URL.createObjectURL(asset.blob);
        blobUrls.push(url);
      }
      return { type: 'file', name: `${baseName}${extension ? `.${extension}` : ''}`, url, sizeBytes: asset.sizeBytes };
    });
    if (files.length === 1) {
      await downloader.downloadFile(files[0].url, files[0].name, assets[0].asset.type, signal);
    } else if (files.length > 1) {
      await downloader.downloadFolder(
        { type: 'folder', name: sanitizeName(archiveName), children: files },
        onProgress,
        signal,
      );
    }
  } finally {
    for (const url of blobUrls) URL.revokeObjectURL(url);
  }
}
